import { render, staticRenderFns } from "./CustomerEditor.vue?vue&type=template&id=46a147cd&scoped=true"
import script from "./CustomerEditor.vue?vue&type=script&lang=js"
export * from "./CustomerEditor.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditor.vue?vue&type=style&index=0&id=46a147cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a147cd",
  null
  
)

export default component.exports